import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SessionService } from 'src/app/services/session.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: "app-impersonation",
  templateUrl: "./impersonation.component.html",
  styleUrls: ["./impersonation.component.scss"],
})
export class ImpersonationComponent implements OnInit, OnDestroy {

  homePageURL: string = "home";
  previousUsername: any;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
    private dialog: MatDialog,
    private sessionService: SessionService,
    private fb: FormBuilder,
    private navigationService: NavigationService,
    private dashboardService: DashboardService,
    private dataService: DataService,
    private apiService: ApiService
	) {}

  allUsers:any = [];
  reqSubcription: Subscription[] = [];
  selectedUsername:any

  ngOnInit(): void {
    this.dialog.closeAll();
    this.previousUsername = this.sessionService.getMainUsername();
    
    this.loadAllUserData()
  }
  
  impersonate() {
    this.dialog.closeAll();
    this.sessionService.setUser(this.selectedUsername.user_id);
    this.sessionService.setUsername(this.selectedUsername.user_id);

    // Remove Client Selection
    sessionStorage.removeItem("client")
    // sessionStorage.
    sessionStorage.removeItem("selectConfig")
    sessionStorage.removeItem("roles")

    // Display name
    this.sessionService.setUserDisplays(this.selectedUsername.user_id);

    // Header Name
    // let findUser:any = this.allUsers.find((res:any)=> res.username == this.selectedUsername.user_id)
    sessionStorage.setItem('userImperson', JSON.stringify(this.selectedUsername))
    this.userLogActivity(this.previousUsername, this.previousUsername+'->'+this.selectedUsername.user_id)
    // Redirect to CLient Selection Page
    setTimeout(() => {
      this.router.navigate([`${this.homePageURL}/`],{ queryParams: { l: '1' } });
    }, 200);

    // setTimeout(() => {
    //   window.location.href = this.homePageURL + "?l=1";
    // }, 200);
  }

  goBack() {
    this.navigationService.goBack();
    setTimeout(() => {
      location.reload()
    }, 100);
  }

  loadAllUserData() {  
    this.reqSubcription.push(this.dashboardService.getAllUserForImpersonate({user_id: this.previousUsername}).subscribe((res:any) => {
      this.allUsers = res ? res : [] 
      this.selectedUsername = this.allUsers[0]
    }))
  }
async userLogActivity(username: any, event: any): Promise<void> {
  const userActivite: any = {
    user_id: username,
    event_name: `userImpersonation ${event}`,
  };

  try {
    // 1️⃣ Get Local (LAN) IP
    userActivite.ip_address = await this.getLocalIP().catch(() => 'Unavailable');

    // 2️⃣ Try to get precise geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude, longitude } = pos.coords;
          userActivite.latitude = latitude;
          userActivite.longitude = longitude;

          // 3️⃣ Reverse-geocode lat/lon → readable address
          try {
            const geo: any = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            ).then((res) => res.json());

            userActivite.location_name = geo.display_name || 'Unknown';
            userActivite.city =
              geo.address?.city || geo.address?.town || geo.address?.village || 'Unknown';
            userActivite.state = geo.address?.state || 'Unknown';
            userActivite.country = geo.address?.country || 'Unknown';
          } catch (geoErr) {
            console.warn('Reverse geocode failed', geoErr);
          }

          this.sendUserActivity(userActivite);
        },
        async (geoError) => {
          console.warn('Geolocation denied', geoError);
          // 🌍 Fallback: Use IP-based lookup
          const ipData: any = await this.getIPInfo();
          Object.assign(userActivite, ipData);

          this.sendUserActivity(userActivite);
        }
      );
    } else {
      // ❌ No geolocation support
      const ipData: any = await this.getIPInfo();
      Object.assign(userActivite, ipData);
      this.sendUserActivity(userActivite);
    }
  } catch (error) {
    console.error('Error in userLogActivity:', error);
    this.sendUserActivity(userActivite);
  }
}

/** 🔄 Fallback: IP-based location lookup */
private async getIPInfo(): Promise<any> {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    return {
      ip_address: data.ip,
      latitude: data.latitude,
      longitude: data.longitude,
      location_name: `${data.city}, ${data.region}, ${data.country_name}`,
      city: data.city,
      state: data.region,
      country: data.country_name
    };
  } catch (e) {
    console.warn('IP-based location lookup failed', e);
    return {};
  }
}

/** 💻 Get local IP (works inside LAN) */
private getLocalIP(): Promise<string> {
  return new Promise((resolve, reject) => {
    const pc = new RTCPeerConnection({ iceServers: [] });
    pc.createDataChannel('');
    pc.createOffer()
      .then((offer) => pc.setLocalDescription(offer))
      .catch(reject);

    pc.onicecandidate = (event) => {
      if (!event || !event.candidate) return;
      const candidate = event.candidate.candidate;
      const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
      const ipMatch = ipRegex.exec(candidate);
      if (ipMatch) {
        resolve(ipMatch[1]);
        pc.close();
      }
    };

    setTimeout(() => reject('Timeout'), 3000);
  });
}

/** 🚀 Send to backend */
private sendUserActivity(data: any): void {
  this.apiService.userActivity(data).subscribe(
    () => console.log('✅ User impersonation activity logged successfully...'),
    (error: any) => console.error('❌ Error logging impersonation activity', error)
  );
}

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}
